import { PermissionsEnum } from '@/auth/interfaces';

export const SAVE_RADIUS_PERMISSIONS = [
  PermissionsEnum.api_view_pais,
  PermissionsEnum.api_view_provincia,
  PermissionsEnum.api_view_ciudad,
  PermissionsEnum.api_view_zona,
  PermissionsEnum.api_view_sector,
  PermissionsEnum.api_view_nodo,
];
